"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var MenuItem_1 = __importDefault(require("semantic-ui-react/dist/commonjs/collections/Menu/MenuItem"));
var genIcon_1 = __importDefault(require("../../../../utils/genIcon"));
var main_1 = require("../../../../main");
/**
 * The Item component is used to create the menu within the Sidebar.
 */
function Item(props) {
    var _a = __assign({}, props), icon = _a.icon, iconRoot = _a.iconRoot, content = _a.content, children = _a.children, BadgeProps = _a.BadgeProps, badge = _a.badge, badgeColor = _a.badgeColor, open = _a.open, name = _a.name, activeName = _a.activeName, iconColor = _a.iconColor, cleanedProps = __rest(_a, ["icon", "iconRoot", "content", "children", "BadgeProps", "badge", "badgeColor", "open", "name", "activeName", "iconColor"]);
    var active;
    if (name && activeName) {
        active = name === activeName ? true : false;
    }
    var menuItemProps = __assign({ link: true, active: active, name: name }, cleanedProps);
    var displayExpander = typeof open === 'boolean';
    var iconProps = { root: iconRoot, className: 'sidebar-icon', color: iconColor };
    var combinedBadgeProps = badge ? { content: badge, color: badgeColor } : undefined;
    var extractedBadgeProps;
    if (React.isValidElement(icon) && icon.props.badge) {
        extractedBadgeProps = {
            content: icon.props.badge,
            color: icon.props.color
        };
    }
    var badgeDisplayProps = BadgeProps || extractedBadgeProps || combinedBadgeProps;
    var expanderIconName = open ? 'caret-up' : 'caret-down';
    var expanderIconProps = {
        root: 'common',
        size: 'small',
        className: 'open-indicator'
    };
    return (React.createElement(MenuItem_1.default, __assign({}, menuItemProps),
        icon && genIcon_1.default(icon, iconProps, badgeDisplayProps),
        React.createElement("span", { className: "sidebar-label" }, content || children),
        badgeDisplayProps && React.createElement(main_1.Badge, __assign({}, badgeDisplayProps)),
        displayExpander && genIcon_1.default(expanderIconName, expanderIconProps)));
}
Item.defaultProps = {
    iconRoot: 'common'
};
exports.default = Item;
